import { Mui, MuiX, DateFns } from '@osu/react-ui'; 
import { useState } from 'react';
import MenuDialogBase from "./MenuDialogBase";
import { useGetApplicationDetailsQueryState, useApplicationAssignReviewMutation } from "../../../services/graphql/api";
import { getApplDetailParams, addBusinessDays } from "../../../util/functions";

export default function DialogAssign({ menuItemAndClose }) {
    const params = getApplDetailParams();
    const { data } = useGetApplicationDetailsQueryState(params);
    const reviewers = data?.configuration.assignableReviewers ?? [];

    const [apiCall, result] = useApplicationAssignReviewMutation();
    const [reviewer, setReviewer] = useState(null);
    const [completedByDueDate, setCompletedByDueDate] = useState(addBusinessDays(new Date(), 5));

    const variables = { reviewerEmployeeIdTo: reviewer?.id, completedByDueDate, manuallyAssigned: true, ...params };
    const isDisabled = !reviewer || isNaN(completedByDueDate);
    const buttons = [{ label: "Assign", apiCall, variables, isDisabled }];
    const message = `You are assigning ${reviewer?.name ?? "a reviewer"} to this applicant.`;

    return (
        <MenuDialogBase menuItemAndClose={menuItemAndClose}
            apiCall={apiCall}
            buttons={buttons}
            result={result}
            extraContent={(
                <>
                    <Mui.Typography tabIndex={0} sx={{ marginBottom: 0 }}>{message}</Mui.Typography>
                
                    <br/>

                    <Mui.FormControl fullWidth required>
                        <Mui.InputLabel id="dialog-assign-choose-reviewer">Choose Reviewer</Mui.InputLabel>
                        <Mui.Select
                            disabled={result?.isLoading || result.isSuccess}
                            sx={{ width: "100%" }}
                            label="Choose Reviewer"
                            labelId="dialog-assign-choose-reviewer"
                            value={reviewer?.id ?? ""}
                            onChange={event => setReviewer(reviewers.find(r => r.id === event.target.value))}>
                                {reviewers.map((item, index) => <Mui.MenuItem key={index} value={item.id}>{item.name}</Mui.MenuItem>)}
                        </Mui.Select>
                    </Mui.FormControl>
                    
                    <br/>
                        
                    <DateFns.LocalizationProvider>
                        <MuiX.DatePicker
                            disabled={result?.isLoading || result.isSuccess}
                            disablePast={true}
                            label="Complete By *"
                            value={completedByDueDate}
                            onChange={setCompletedByDueDate}
                            sx={{ marginTop: "1em", width: "100%" }}
                            required
                        />
                    </DateFns.LocalizationProvider>
                </>
            )}
        />
    );
}